module.exports = __webpack_public_path__ + "static/media/june_2025_5.bd7d640c.webp";